<template>
  <div>
    <div v-if="!$route.query.external" class="card">
      <div class="card-header">
        <router-link :to="{ name: 'instructions' }" class="float-left">
          <font-awesome-icon icon="angle-left" class="text-warning mr-2" />
          <span class="text-white">{{ $t("back") }}</span>
        </router-link>
        <span>{{ item.subject }}</span>
      </div>
      <div class="card-body py-4 px-5">
        <div v-if="item.options">
          <div class="row">
            <div class="details-wrapper col-12">
              <div class="row" v-if="item.options">
                <div v-if="item.options.instruction_id" class="col-12">
                  <h6>{{ $t("dear_client") }}</h6>
                  <br />
                  <span>
                    {{
                      $t("instruction_detail_in_attachment", {
                        id: item.options.instruction_idno
                      })
                    }}
                  </span>
                </div>

                <div
                  v-else-if="
                    item.options.transactionType ||
                      item.options.toConfirmTrade ||
                      item.options.toConfirmWithdrawal
                  "
                  class="col-12"
                >
                  <h6>{{ $t("dear_client") }}</h6>
                  <br />
                  <span v-if="item.options.toConfirmWithdrawal === true">
                    {{
                      $t("instruction_for_cash_transaction_type", {
                        transactionType:
                          item.options.transactionType === "withdrawal"
                            ? $t("withdrawal")
                            : $t("deposit")
                      })
                    }}
                  </span>
                  <span v-else-if="item.options.toConfirmTrade === true">
                    {{
                      $t("instruction_for_asset_transaction_type", {
                        transactionType:
                          item.options.transactionType === "buy"
                            ? $t("purchase")
                            : $t("sale")
                      })
                    }}
                  </span>
                  <span v-else>
                    {{
                      $t(
                        "instruction_for_cash_transaction_type_was_registered",
                        {
                          transactionType:
                            item.options.transactionType === "withdrawal"
                              ? $t("withdrawal")
                              : $t("deposit")
                        }
                      )
                    }}
                  </span>
                  <br />
                  <table class="my-4">
                    <tr>
                      <td class="pr-4">
                        <b>{{ $t("investment_strategy") }}:</b>
                      </td>
                      <td>{{ item.options.strategyName }}</td>
                    </tr>
                    <tr v-if="item.options.date">
                      <td>
                        <b>{{ $t("instruction_validity") }}:</b>
                      </td>
                      <td>{{ item.options.date | date }}</td>
                    </tr>
                    <tr>
                      <td>
                        <b>{{ $t("amount") }}:</b>
                      </td>
                      <td>{{ item.options.value }}</td>
                    </tr>
                  </table>

                  <template
                    v-if="
                      item.options.toConfirmTrade ||
                        item.options.toConfirmWithdrawal
                    "
                  >
                    <template v-if="item.options.accepted">
                      <span class="sfa-status sfa-status-success" v-if="isSfa">
                        {{ $t("sent_intruction") }}
                      </span>
                    </template>
                    <template v-else>
                      <span class="sfa-status sfa-status-warning" v-if="isSfa">
                        {{ $t("waiting_for_approval") }}
                      </span>
                      <button
                        v-else
                        @click="createInstructionSfa()"
                        class="btn btn-warning"
                      >
                        <!--									<font-awesome-icon icon="file-pdf" class="mr-2"/>-->
                        {{ $t("execute_instruction") }}
                      </button>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div
            class="mt-4 mb-3 pt-3 text-center"
            v-if="item.options.instruction_id"
          >
            <button @click="downloadInstruction" class="btn btn-warning">
              <font-awesome-icon
                v-if="loading"
                icon="spinner"
                class="mx-2"
                spin
              />
              <font-awesome-icon v-else icon="file-pdf" class="mr-2" />
              {{ $t("download_instruction_detail") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-header">
        <router-link :to="{ name: 'instructions' }" class="float-left">
          <font-awesome-icon icon="angle-left" class="text-warning mr-2" />
          <span class="text-white">{{ $t("back") }}</span>
        </router-link>
        <span>{{ externalItem.subject }}</span>
      </div>
      <div class="card-body py-4 px-5">
        <div class="row">
          <div class="col-6">{{ $t("strategy") }}:</div>
          <div class="col-6">{{ externalItem.subject }}</div>
        </div>
        <div class="row">
          <div class="col-6">{{ $t("investmentType") }}:</div>
          <div class="col-6 text-capitalize">
            {{ externalItem.recursive ? $t("recurrent") : $t("onetime") }}
          </div>
        </div>
        <div class="row">
          <div class="col-6">{{ $t("totalInvestmentAmount") }}:</div>
          <div class="col-6">
            {{ externalItem.totalAmount.toLocaleString("sk-SK") }} €
          </div>
        </div>
        <div v-if="externalItem.recursive" class="row">
          <div class="col-6">{{ $t("monthlyInvestment") }}:</div>
          <div class="col-6">
            {{ externalItem.monthlyInvestment.toLocaleString("sk-SK") }} €
          </div>
        </div>
        <div class="row">
          <div class="col-6">{{ $t("totalFeeAmount") }}:</div>
          <div class="col-6">
            {{ externalItem.feeAmount.toLocaleString("sk-SK") }} € ({{
              externalItem.feePercentage
            }}%)
          </div>
        </div>
        <div class="row">
          <div class="col-6">{{ $t("feesPayment") }}:</div>
          <div class="col-6">
            {{ translatedVariable }}
          </div>
        </div>
        <div class="row">
          <div class="col-6">{{ $t("contract") }}:</div>
          <div class="col-6">
            <a target="_blank" :href="externalItem.contractUrl">{{
              $t("contractPreview")
            }}</a>
          </div>
        </div>
      </div>

      <div class="card-footer text-center">
        <button
          v-if="!externalItem.success"
          @click="triggerOTP"
          class="btn btn-success"
        >
          <font-awesome-icon v-if="loading" icon="spinner" class="mx-2" spin />
          <font-awesome-icon v-else icon="check" class="mr-2" />
          {{ $t("verifyOrderBySMS") }}
        </button>
        <div v-else-if="externalItem.otpConfirmed">
          {{ $t("orderConfirmed") }}
        </div>
        <div v-else>
          <div class="row">
            <div class="col-4">{{ $t("insertOTP") }}:</div>
            <div class="col-4">
              <input
                class="form-control"
                type="text"
                v-model="externalItemData.otp"
                :min="0"
                :max="6"
                required
              />
            </div>
            <div class="col-4">
              <button
                @click.prevent="confirmOTP"
                class="btn btn-success"
                :disabled="!externalItem.otp"
              >
                {{ $t("confirmOrder") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "InstructionDetail",
  async created() {
    if (!this.$route.query.external) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _that = this;

      await this.$store.dispatch("messages/messageDetail", {
        id: this.$route.params.id
      });
    } else {
      const {
        data: { data }
      } = await axios.get(
        process.env.VUE_APP_MOCKAPI_BASE_URL +
          "portfolio-orders/" +
          this.$route.params.id +
          "?populate=*",
        {
          headers: {
            Authorization: "Bearer " + process.env.VUE_APP_MOCKAPI_TOKEN
          },
          withCredentials: true
        }
      );

      let totalAmount = 0;
      if (data.attributes.recursive) {
        const calc =
          data.attributes.investment_amount *
          data.attributes.years_to_invest *
          12;
        totalAmount = Math.round(calc * 100) / 100;
      } else {
        totalAmount = data.attributes.investment_amount;
      }

      const fee = (totalAmount / 100) * data.attributes.fee_percentage;

      this.externalItemData = {
        id: data.id,
        subject: data.attributes.portfolio_strategy.data.attributes.title,
        recursive: data.attributes.recursive,
        totalAmount: totalAmount,
        monthlyInvestment: data.attributes.investment_amount,
        feeAmount: Math.round(fee * 100) / 100,
        feePercentage: data.attributes.fee_percentage,
        feeStrategy: data.attributes.fee_strategy,
        contractUrl:
          data.attributes.portfolio_strategy.data.attributes.contract_url,
        success: data.attributes.otps.data.length > 0,
        otpConfirmed: false
      };

      if (data.attributes.otps.data.length > 0) {
        this.externalItemData.otpId = data.attributes.otps.data[0].id;

        const response = await axios.get(
          process.env.VUE_APP_MOCKAPI_BASE_URL +
            "otps/" +
            this.externalItemData.otpId +
            "?populate=*",
          {
            headers: {
              Authorization: "Bearer " + process.env.VUE_APP_MOCKAPI_TOKEN
            },
            withCredentials: true
          }
        );

        if (response.data.data.attributes.acceptance.data) {
          this.externalItemData.otpConfirmed = true;
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      instructionToCreate: {},
      externalItemData: {
        id: "",
        subject: "",
        recursive: false,
        totalAmount: 0,
        monthlyInvestment: 0,
        feeAmount: 0,
        feePercentage: 0,
        feeStrategy: "",
        contractUrl: "",
        success: false,
        otpConfirmed: false,
        otp: "",
        otpId: ""
      }
    };
  },
  computed: {
    translatedVariable() {
      switch (this.externalItemData.feeStrategy) {
        case "atOnce":
          return this.$t("onetimeFee");
        case "perPayment":
          return this.$t("perPaymentFee");
        case "halfTillPaid":
          return this.$t("halfTillPaidFee");
        default:
          return "";
      }
    },
    externalItem() {
      return this.externalItemData;
    },
    item() {
      return this.$store.state.messages.item;
    },
    assignedToMe() {
      return this.$store.state.account.assignedToMe;
    },
    isSfa() {
      if (this.assignedToMe.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async confirmOTP() {
      try {
        const {
          data: { data }
        } = await axios.post(
          process.env.VUE_APP_MOCKAPI_BASE_URL + "acceptances",
          {
            data: {
              client_id: this.$store.state.account.profileInfo.uuid,
              otp: this.externalItemData.otp,
              otp_id: this.externalItemData.otpId,
              name: this.$store.state.account.profileInfo.name,
              surname: this.$store.state.account.profileInfo.surname,
              birth_number: this.$store.state.account.profileInfo.birthnumber,
              email: this.$store.state.account.profileInfo.email
            }
          },
          {
            headers: {
              Authorization: "Bearer " + process.env.VUE_APP_MOCKAPI_TOKEN
            },
            withCredentials: true
          }
        );

        this.externalItemData.otpConfirmed = true;
      } catch (e) {
        console.log(e);
        this.externalItemData.otpConfirmed = false;
      }
    },
    async triggerOTP() {
      try {
        const {
          data: { data }
        } = await axios.post(
          process.env.VUE_APP_MOCKAPI_BASE_URL + "otps",
          {
            data: {
              phone_number: this.$store.state.account.profileInfo.phone.replace(
                /\s/g,
                ""
              ),
              portfolio_order: this.externalItemData.id
            }
          },
          {
            headers: {
              Authorization: "Bearer " + process.env.VUE_APP_MOCKAPI_TOKEN
            },
            withCredentials: true
          }
        );

        this.externalItemData.success = true;
        this.externalItemData.otpId = data.id;
      } catch (e) {
        console.log(e);
        this.externalItemData.success = false;
      }
    },
    downloadInstruction() {
      this.loading = true;
      this.$store
        .dispatch("messages/downloadInstruction", this.item.options)
        .then(() => {
          this.loading = false;
        });
    },
    createInstructionSfa() {
      this.$store
        .dispatch("messages/messageDetail", {
          id: this.$route.params.id
        })
        .then(res => {
          const options = res.options;
          const sfaRequest = this.$root.$children[0].$children[1].$children[1];

          this.$store.commit("instructions/setSfaInstruction", options);

          if (options.toConfirmWithdrawal === true) {
            sfaRequest.showModal("withdrawal");
          } else {
            sfaRequest.showModal("trade");
          }
        });
    }
  }
};
</script>

<style lang="scss">
.pre-wrap {
  white-space: pre-wrap;
}

.sfa-status {
  padding: 8px 12px;
  border: 3px solid $success;

  &-success {
    border-color: $success;
  }

  &-warning {
    border-color: darken($warning, 10%);
  }
}
</style>
